export default __webpack_public_path__ + "static/media/cc2021 (6).d182b88c.jpg";